var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReward2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 434,
    height: 353,
    viewBox: "0 0 434 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M214.922 22C121.877 22 46.4492 97.428 46.4492 190.473C46.4492 266.73 97.1182 331.141 166.622 351.907H263.222C332.726 331.141 383.395 266.73 383.395 190.473C383.395 97.428 307.967 22 214.922 22Z",
    fill: "#00A86B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.328 141.223H0V263.55H122.328V141.223Z",
    fill: "#605DE8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M250.922 205.457C283.94 205.457 310.707 178.69 310.707 145.672C310.707 112.653 283.94 85.8867 250.922 85.8867C217.903 85.8867 191.137 112.653 191.137 145.672C191.137 178.69 217.903 205.457 250.922 205.457Z",
    fill: "#FFA905"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M330.488 14.1289L267.355 123.478H393.62L330.488 14.1289Z",
    fill: "#6661FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M226.686 149.125L217.598 164.864H235.773L226.686 149.125Z",
    fill: "#FF5221"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8487 47.2742L97.9357 31.5352H79.7617L88.8487 47.2742Z",
    fill: "#FFA905"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M409.743 147.767L418.83 132.027H400.656L409.743 147.767Z",
    fill: "#639CFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M220.929 329.631C220.642 329.631 220.35 329.624 220.051 329.61L220.32 323.876C226.374 324.155 228.271 319.916 228.467 319.43L233.828 321.481C233.698 321.825 230.648 329.631 220.929 329.631Z",
    fill: "#333D4D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M236.62 12.097L235.305 6.511C241.208 5.122 241.865 0.52 241.92 0L247.638 0.502998C247.607 0.876998 246.769 9.709 236.62 12.097Z",
    fill: "#FF5221"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M166.255 82.5147C166.039 82.2077 161.034 74.8817 167.309 66.5547L171.893 70.0087C168.244 74.8507 170.681 78.8087 170.971 79.2437L166.255 82.5147Z",
    fill: "#FFC444"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M378.704 64.7541L374.059 61.3851C374.278 61.0801 379.539 53.9331 389.468 57.1011L387.725 62.5691C381.945 60.7281 379.02 64.3371 378.704 64.7541Z",
    fill: "#FFA905"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7651 115.259C42.3891 115.251 33.5231 114.937 30.5391 104.947L36.0381 103.305C37.7731 109.113 42.4061 109.497 42.9291 109.523L42.7651 115.259Z",
    fill: "#FFA905"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M248.421 218.423L244.79 239.888L191.75 251.51L174.488 266.077L212.539 293.422C212.539 293.422 231.012 293.136 244.791 291.332C258.57 289.528 270.674 291.204 286.429 274.324C302.184 257.444 299.033 215.805 299.033 215.805L248.421 218.423Z",
    fill: "#936149"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M244.117 240.09C245.392 240.317 246.667 240.545 247.942 240.772",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M313.437 351.99H258.246L266.644 299.109L372.217 307.697L313.437 351.99Z",
    fill: "#FFA905"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M316.315 308.08C315.592 315.585 314.868 323.09 314.145 330.595C317.671 330.561 321.391 330.651 324.918 330.617C325.836 322.808 325.918 314.981 326.837 307.172",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M279.94 307.059C273.968 316.006 267.995 324.954 262.023 333.902",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M234.938 221.16C234.938 221.16 239.587 213.048 248.421 197.743C257.255 182.438 268.828 173.196 283.852 169.36C298.876 165.524 331.324 160.066 331.324 160.066C331.324 160.066 360.195 165.454 378.764 169.36C397.332 173.266 403.38 176.361 416.055 192.792C428.73 209.222 433.501 225.934 433.501 225.934L386.279 231.513L385.15 311.891L260.348 307.392L270.93 228.886L234.938 221.16Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M366.291 233.589C365.663 223.28 366.379 212.89 368.416 202.765C369.87 195.539 374.019 188.984 380.122 184.851C386.224 180.717 393.942 179.04 401.209 180.269",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M270.42 229.533C271.1 222.556 271.779 215.579 272.459 208.603C273.423 198.71 269.194 188.497 264.887 179.539",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M293.488 169.02C295.572 178.691 302.362 187.233 311.313 191.446C320.264 195.659 331.174 195.447 339.955 190.89C348.736 186.333 355.189 177.534 356.896 167.789",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M262.34 299.766C295.731 300.776 329.123 301.785 362.514 302.795",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M425.234 226.91C425.234 226.91 427.861 265.962 427.818 288.936C427.775 311.91 416.735 321.46 407.355 331.605C397.976 341.75 387.176 351.989 387.176 351.989H313.438C313.438 351.989 344.771 317.791 370.855 290.88L371.603 232.679L425.234 226.91Z",
    fill: "#936149"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M370.605 291.43C372.781 290.08 374.956 288.729 377.132 287.379",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M351.146 166.597C349.011 166.06 346.768 165.486 344.633 164.949C344.246 161.383 343.859 157.816 343.472 154.25C331.004 154.636 318.413 154.24 306.014 152.875C306.632 157.599 307.016 162.362 307.635 167.086C305.682 167.528 303.473 168.031 301.52 168.472C303.784 175.407 308.877 181.4 315.664 184.075C322.451 186.75 330.349 186.353 336.911 183.165C343.472 179.976 348.695 173.468 351.146 166.597Z",
    fill: "#936149"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M354.052 124.523C357.379 122.137 358.695 117.318 357.044 113.572C355.393 109.826 351.248 107.516 347.242 108.36C347.131 107.302 346.581 106.296 345.75 105.631C344.919 104.966 343.92 104.829 342.863 104.953C343.56 101.134 341.396 96.9777 337.868 95.3587C334.34 93.7397 329.977 94.7257 327.537 97.7447C326.253 95.9977 324.059 94.9617 321.895 95.0797C319.73 95.1977 317.808 96.4597 316.723 98.3357C313.392 96.9637 309.37 97.4247 306.436 99.5157C303.502 101.606 301.752 105.257 301.96 108.853C302.168 112.449 304.328 115.874 307.483 117.611C305.614 123.962 302.809 129.836 299.643 135.65C298.392 135.573 297.266 135.429 296.015 135.351C294.687 139.966 293.774 144.728 293.805 149.53C293.83 153.432 295.828 157.198 298.396 160.135C300.965 163.072 304.494 165.154 308.306 165.982C316.241 167.706 324.544 168.683 332.227 166.055C339.91 163.427 346.587 157.475 349.242 149.801L353.652 137.875C356.522 136.986 358.685 134.174 358.806 131.172C358.929 128.169 356.841 125.641 354.052 124.523Z",
    fill: "#150D0D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M356.502 138.05C354.71 134.016 350.25 131.335 345.848 131.645L341.828 152.16C345.789 154.109 350.93 153.309 354.112 150.25C357.293 147.19 358.294 142.084 356.502 138.05Z",
    fill: "#936149"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M344.668 141.056C346.86 140.807 349.051 140.558 351.243 140.309",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M336.629 143.225C338.564 138.717 340.523 134.239 342.458 129.731C341.342 128.692 340.685 127.044 341.009 125.555C339.132 125.506 337.293 124.615 336.091 123.173C334.889 121.731 334.181 119.821 334.469 117.966C332.442 118.505 330.102 117.562 329.372 115.596C327.818 116.899 325.604 117.368 323.655 116.808C321.706 116.247 320.146 114.605 319.522 112.675C316.094 112.165 312.508 112.776 309.442 114.394C306.376 116.012 303.798 118.602 302.239 121.698C299.676 126.789 297.927 132.289 297.078 137.926C310.474 137.298 323.892 139.029 336.629 143.225Z",
    fill: "#936149"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M317.668 141.986C317.596 143.559 318.446 145.141 319.797 145.948C321.149 146.755 322.944 146.754 324.295 145.945C325.646 145.136 326.494 143.553 326.42 141.98L317.668 141.986Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M305.882 133.041C306.938 133.041 307.795 132.184 307.795 131.128C307.795 130.071 306.938 129.215 305.882 129.215C304.825 129.215 303.969 130.071 303.969 131.128C303.969 132.184 304.825 133.041 305.882 133.041Z",
    fill: "#150D0D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M328.775 135.171C328.775 134.115 327.918 133.258 326.862 133.258C325.806 133.258 324.949 134.115 324.949 135.171C324.949 136.228 325.806 137.084 326.862 137.084C327.919 137.084 328.775 136.227 328.775 135.171Z",
    fill: "#150D0D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M315.983 130.906C314.93 133.343 313.877 135.779 312.824 138.216C313.648 138.304 314.472 138.391 315.295 138.479",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M326.586 122.004C328.613 122.676 330.639 123.349 332.666 124.021",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M315.589 120.777C315.236 118.456 313.566 116.382 311.374 115.54C309.182 114.699 306.553 115.124 304.738 116.613",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M178.17 351.993H37.8991L32.9961 302.578L170.407 303.825L178.17 351.993Z",
    fill: "#639CFF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2109 320.918C60.4609 330.801 61.8389 340.655 64.3109 350.227",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M122.93 337.816C123.947 342.325 124.965 346.834 125.982 351.343",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5501 169.547C96.5501 169.547 89.9551 170.45 75.8781 172.872C61.8011 175.294 55.7191 182.146 46.1561 199.427C36.5931 216.707 15.2691 276.511 20.9801 321.221H177.708L174.482 268.474L193.078 250.201C193.078 250.201 184.02 223.398 178.166 207.449C172.311 191.5 165.084 186.698 153.168 180.996C141.252 175.294 105.143 167.309 105.143 167.309L96.5501 169.547Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0508 173.382C79.3108 173.146 85.6248 175.684 89.9788 180.186C94.3338 184.689 96.6588 191.084 96.2138 197.332C94.9768 214.697 92.9828 232.263 91.2478 249.585C107.602 249.855 124.221 249.796 140.576 250.066",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8287 195.277C41.1927 218.713 37.3337 243.375 37.4437 268.023C37.4877 277.927 39.9457 287.721 45.9347 295.609C52.8897 304.771 64.9327 308.893 76.4347 309.037C94.7437 309.265 112.848 307.779 130.874 304.565",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0614 249.336C87.9104 250.087 84.7594 250.838 81.6094 251.589",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M154.195 182.27C154.481 205.452 154.767 228.635 155.052 251.818",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1041 298.406C46.9011 305.834 46.6991 313.262 46.4961 320.69",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M115.174 250.191C112.9 269.253 110.626 288.316 108.352 307.378",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M125.725 258.344C125.405 260.592 125.086 262.84 124.766 265.088",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5156 169.84L107.723 204.159L120.422 182.562L132.695 203.862L139.875 175.739L94.5156 169.84Z",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M142.223 132.141C134.13 123.008 120.794 119.761 109.091 123.22C103.474 124.88 98.4628 128.516 95.1408 133.34C91.8198 138.164 90.8918 144.285 91.0098 150.141C91.0588 152.561 91.1077 154.98 91.1567 157.4C98.0037 161.537 104.815 165.338 111.662 169.475L136.643 149.563C140.219 148.729 143.26 145.901 144.352 142.395C145.444 138.89 144.658 134.889 142.223 132.141Z",
    fill: "#333D4D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M122.438 185.215C124.604 185.391 126.79 185.171 128.914 184.715C133.561 183.717 138.055 181.494 141.135 177.873C144.215 174.252 145.138 169.092 144.567 164.373C144.022 159.865 143.085 155.409 142.795 150.877C142.561 147.22 139.917 144.198 136.517 142.828C126.738 144.727 117.23 146.71 107.451 148.609C106.43 151.582 105.215 154.334 104.193 157.308C103.453 155.878 102.567 154.622 101.827 153.192C97.811 151.345 92.651 152.409 89.694 155.694C86.736 158.979 86.217 164.222 88.474 168.022C90.731 171.823 95.582 173.877 99.882 172.853C105.16 179.906 113.658 184.501 122.438 185.215Z",
    fill: "#774F3B"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M124.336 168.902C124.057 169.848 124.39 170.945 125.149 171.575C125.908 172.205 127.048 172.331 127.926 171.882C128.804 171.433 129.37 170.435 129.304 169.451L124.336 168.902Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M122.335 164.564C123.391 164.564 124.248 163.708 124.248 162.651C124.248 161.595 123.391 160.738 122.335 160.738C121.278 160.738 120.422 161.595 120.422 162.651C120.422 163.708 121.278 164.564 122.335 164.564Z",
    fill: "#150D0D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M144.861 158.89C144.861 157.833 144.004 156.977 142.948 156.977C141.891 156.977 141.035 157.834 141.035 158.89C141.035 159.946 141.892 160.803 142.948 160.803C144.005 160.803 144.861 159.947 144.861 158.89Z",
    fill: "#150D0D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M116.191 156.479C116.631 154.805 117.906 153.373 119.517 152.742C121.128 152.11 123.036 152.295 124.497 153.224",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M134.043 149.395C136.454 147.848 139.52 147.362 142.291 148.087",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M129.411 160.227C130.238 162.29 131.065 164.352 131.891 166.415C130.954 166.535 129.925 166.859 128.988 166.979",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6719 159.254C95.7549 159.874 97.8389 160.495 99.9219 161.115",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M136.584 302.751C151.998 308.327 168.497 312.876 184.626 315.794C185.777 316.002 187.013 315.677 187.912 314.929C188.811 314.181 189.524 313.201 189.529 312.031C191.439 312.551 193.503 312.786 195.453 313.124C197.285 313.441 199.268 312.572 200.277 311.01C201.285 309.448 201.543 307.673 200.5 306.134C201.398 306.315 203.048 306.571 203.902 306.902C205.532 307.533 207.493 307.216 208.841 306.102C210.189 304.989 210.978 302.532 210.666 300.812C212.305 301.78 214.114 302.723 216.007 302.526C217.768 302.343 219.372 301.084 219.969 299.418C220.566 297.752 220.534 295.663 219.234 294.462C206.366 282.575 193.525 270.401 180.657 258.514L184.803 246.913C181.088 241.22 175.52 239.777 167.176 243.511C158.833 247.245 147.922 252.64 147.922 252.64L138.72 253.16L130.617 302.578L136.584 302.751Z",
    fill: "#885A44"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M201.281 295.594C204.72 297.639 208.16 299.684 211.599 301.729L201.281 295.594Z",
    fill: "#55382A"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M201.281 295.594C204.72 297.639 208.16 299.684 211.599 301.729",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M193.059 303.457C196.113 304.358 199.166 305.259 202.22 306.16L193.059 303.457Z",
    fill: "#55382A"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M193.059 303.457C196.113 304.358 199.166 305.259 202.22 306.16",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M185.402 310.891C187.045 311.367 188.688 311.843 190.331 312.318L185.402 310.891Z",
    fill: "#55382A"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M185.402 310.891C187.045 311.367 188.688 311.843 190.331 312.318",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M176.532 316.416C175.777 318.489 173.625 319.968 171.419 319.929C169.213 319.891 167.42 318.476 166.737 316.378C165.43 317.747 163.698 318.759 161.819 318.987C159.94 319.215 157.926 318.592 156.664 317.182C155.402 315.771 154.474 313.54 155.39 311.884C153.9 314.084 150.856 315.084 148.351 314.195C145.847 313.307 143.994 310.573 144.223 307.926C142.837 309.828 140.054 310.556 137.914 309.577C135.774 308.598 134.427 305.822 135.294 303.634C137.054 299.195 138.814 294.756 140.574 290.317C141.478 289.658 143.195 289.655 143.861 290.553C144.527 291.451 144.68 292.618 144.811 293.728C145.225 297.236 145.639 300.744 146.053 304.253C148.291 299.396 150.702 294.818 153.746 290.422C154.472 289.374 156.21 290.453 156.765 291.601C157.32 292.749 157.241 294.089 157.15 295.36C156.816 300.018 156.482 304.677 156.149 309.335C158.497 304.517 161.146 299.776 163.494 294.958C164.493 294.355 165.994 295.011 166.568 296.027C167.143 297.043 167.137 298.273 167.116 299.44C167.035 303.916 166.954 308.392 166.874 312.868C168.663 310.103 170.626 307.262 172.415 304.498C173.151 304.159 174.188 304.005 174.746 304.593C175.304 305.181 175.577 305.979 175.786 306.762C176.521 309.512 177.507 313.74 176.532 316.416Z",
    fill: "#936149"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M146.192 301.781C145.573 303.951 144.955 306.122 144.336 308.292",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M156.964 305.375C156.223 308.078 155.482 310.782 154.742 313.485",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M167.358 310.34C167.039 312.513 166.721 314.686 166.402 316.859",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M195.819 245.388C191.182 242.98 185.189 242.292 180.192 243.819C173.724 245.797 167.47 247.99 161.002 249.967C158.594 256.477 156.186 262.988 153.777 269.498C154.892 271.007 156.985 271.119 158.788 270.6C160.591 270.082 162.099 268.866 163.552 267.679C165.758 265.878 167.963 264.077 170.169 262.276C177.187 263.385 183.819 264.092 190.837 265.201L205.824 256.963C204.114 252.028 200.456 247.796 195.819 245.388Z",
    fill: "#936149"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M186.719 264.648C188.295 265.548 189.87 266.449 191.446 267.349",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M169.163 262.399C168.338 261.799 167.513 261.199 166.688 260.598",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M200.414 248.949C201.389 249.549 202.364 250.15 203.339 250.75",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6641 351.992H410.774",
    stroke: "#150D0D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward2);
export default __webpack_public_path__ + "static/media/reward2.fe0915e0af5c82cc3a502a88c8145e0b.svg";
export { ForwardRef as ReactComponent };